<template>
	<div class="baseBody relative">
		<div class="backBtn text-white" style="cursor: pointer;" @click="goBack" >返回</div>
		<div class="dateWeek">
			<DynamicDate></DynamicDate>
		</div>
		<div class="topHead flex justify-between">
			<div class="leftHead"></div>
			<div class="midHead">{{cityName}}招商资源情况</div>
			<div class="rightHead"></div>
		</div>
		<div id="mainSf" ref="mainSf"></div>
		
		<el-dialog :visible.sync="dialogTableVisible" width="50%" customClass="mapTcStyle">
			<template v-if="dialogTableVisible">
				<dv-border-box-10 :color="['#064a80', '#01e3eb']" title="dv-border-box-11">
					<div
						style="box-sizing: border-box;padding:5px;background: #051b35;box-shadow:0 0 30px inset #064a80;border-radius:60px;">
						<div class="tcNeiBox" style="width:100%;height:450px;border-radius:20px;">
							<div class="text-center tcNeiTitle text-white">{{xmInfo.name}}</div>
							<div style="padding:15px 25px;box-sizing:border-box;">
								<div class="textInfo gdt " v-html="xmInfo.description">
								
								</div>
							</div>
						</div>
					</div>
		
				</dv-border-box-10>
			</template>
		</el-dialog>
		
	</div>
</template>

<script>
	import DynamicDate from "../../components/dynamicDate/index.vue";
	// import router from '../../router';
	import {
		getProjectList
	} from "@/api/api"
	export default {
		inject: ['reload'],
		components: {
			DynamicDate,
		},
		data() {
			return {
				dialogTableVisible:false,
				showSfZszyL: [],
				xmList:[],
				xmInfo:{},
				city:'',
				cityName:'',
				myChart:null
			}
		},
		mounted() {
	
			this.city=this.$route.query.city;
      this.cityName=this.$route.query.name;
			// if(this.$route.query.name.indexOf('市')==-1){
			// 	this.cityName=this.$route.query.name+'省'
			// }
			// else{
			// 	this.cityName=this.$route.query.name
			// }
			
			this.$nextTick(function () {
			       this.getProjectList()
			 })
			
		},
		beforeDestroy() {
		      /* 页面组件销毁的时候，别忘了移除绑定的监听resize事件，否则的话，多渲染几次
		      容易导致内存泄漏和额外CPU或GPU占用哦*/
		      window.removeEventListener("resize", () => {
		        this.myChart.resize();
		      });
		},
		methods: {
			
			goBack(){
				this.$router.go(-1)
			},
			initMap() {
				// location.reload()
				let _self=this
				// let myChart = this.$echarts.init(document.getElementById("main"));
				
				 // let mapDiv = document.getElementById('mainSf')
				     _self.myChart = _self.$echarts.init(this.$refs.mainSf)
				      let city = _self.city
				      //动态引入省份json文件
				      _self.cityJson = require(`echarts/map/json/province/${city}.json`)
					  // con
				      _self.$echarts.registerMap(_self.city, _self.cityJson, {})
				 _self.myChart.clear()
				 _self.myChart.setOption({
					// 配置项(组件)
					geo: {
						map:_self.city,
						// 地图的长宽比例
						aspectScale: 0.75,
						// 图层
						zoom: 1.1,
						// 样式
						itemStyle: {
							normal: {
								borderColor: "#80c4dc",
								borderWidth:3,
								areaColor: 'rgba(7,34,124,0.8)',
								fontWeightL: 700,
								shadowColor: 'rgba(19, 59,165, 1)',
								shadowOffsetX: -2,
								shadowOffsetY: 2,
								shadowBlur: 10
							},
							emphasis: {
								areaColor: '#389BB7',
								borderWidth: 0
							},
						},
				
						region: [{
							name: "南海诸岛",
							itemStyle: {
								opacity: 0,
							},
						}, ],
					},
					series: [
						// 配置地图相关的数据参数
						{
							type: "map",
							// symbol: 'pin', //气泡
							label: {
								normal: {
									// 显示文字
									show: true,
									textStyle: {
										color: "#1DE9B6",
									},
				
								},
								emphasis: {
									textStyle: {
										color: "rgb(183,185,14)",
									},
								},
							},
							data: _self.showSfZszyL,
				
							// 图层
							zoom: 1.1,
							map: _self.city,
							itemStyle: {
								normal: {
									areaColor: {
										colorStops: [{
												offset: 0,
												color: "rgb(5,108,236)"
											},
											{
												offset: 1,
												color: "rgb(5,41,134)"
											},
										],
									},
									borderColor: '#fff',
									fontWeightL: 700,
									borderWidth: 1,
								},
								// 高亮效果
								emphasis: {
									areaColor: "rgb(46,229,206)",
									borderWidth: 0.1,
								},
							},
						},
						// 区域散点图
						{
							type: 'effectScatter',
							coordinateSystem: 'geo',
							zlevel: 2,
							symbolSize: 10,
							rippleEffect: { //坐标点动画
								period: 3,
								scale: 5,
								brushType: 'fill'
							},
							label: {
							  normal: {
							    show: false,
							    // position: 'right',
							    // formatter: '{b}',
							    // color: '#b3e2f2',
							    // fontWeight: 'bold',
							    // fontSize: 16
							  }
							},
							data:_self.showSfZszyL,
							itemStyle: { //坐标点颜色
								normal: {
									show: true,
									color: '#ff8003',
									shadowBlur: 20,
									shadowColor: '#fff'
								},
								emphasis: {
									areaColor: '#f00'
								}
							}
						},
						{
							type: 'lines',
							zlevel: 3,
							symbol: 'circle',
							symbolSize: [5, 5],
							color: '#ff8003',
							opacity: 1,
							label: {
								show: true,
								padding: [10, 20],
								color: '#fff',
								backgroundColor: '#1a3961',
								borderColor: '#aee9fb',
								borderWidth: 1,
								borderRadius: 6,
								formatter(params) {
									let arr = [params.name];
									// return arr.join('\n');
									return arr
								},
								textStyle: {
									align: 'left',
									lineHeight:20,
									fontSize:16
								}
							},
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: 0.5,
								opacity: 1
							},
							data: _self.showSfZszyL
						}
					],
				},true);
				window.addEventListener('resize', function () {
				       _self.myChart.resize();
				})
				 _self.myChart.on("click", function(params) { //点击事件

					if (params.componentSubType == "lines") {
						// _self.xmList.forEach(function(item){
						// 	if(params.name==item.name){
						// 		_self.xmInfo=item
						// 	}
						// })
						_self.xmList.forEach(item=>{
							if(params.name==item.name){
								_self.xmInfo=item
							}
						})
						
						
					_self.dialogTableVisible=true
					
					} else if (params.componentSubType == "effectScatter") {
						
						console.log('进入下个城市', params)
					}
				});
			
			
			
			},
			getProjectList() {
				let _self=this
				getProjectList(2,_self.cityName).then(res => {
					_self.xmList=res.data
					var n=0
					res.data.forEach(function(item,index){
						n+=0.322
						if(item.name.indexOf("上海")!==-1){
							_self.showSfZszyL.push({
									"name": item.name,
									"value": [item.longitude*1,item.latitude*1],
									"coords": [
										[item.longitude*1,item.latitude*1],
										[item.longitude*1+0.301,item.latitude*1+0.123]
									]
							})
						}else{
              if(index%2==0){
                _self.showSfZszyL.push({
                  "name": item.name,
                  "value": [item.longitude*1,item.latitude*1],
                  "coords": [
                    [item.longitude*1,item.latitude*1],
                    [item.longitude*1+n*2,item.latitude*1+n]
                  ]
                })
              }else{
                _self.showSfZszyL.push({
                  "name": item.name,
                  "value": [item.longitude*1,item.latitude*1],
                  "coords": [
                    [item.longitude*1,item.latitude*1],
                    [item.longitude*1-n*4,item.latitude*1+n]
                  ]
                })
              }

            }
						
					})
					
					_self.initMap()
				})
			}
		}
	}
</script>

<style>
	.backBtn{width:80px;height:40px;position:absolute;right:20px;top:5px;z-index:99999;line-height:40px;text-align:center;font-size:16px;border-radius: 7px;cursor:poiter;display: block;
	background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); /* Safari 5.1 - 6.0 */
	 background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); /* Opera 11.1 - 12.0 */
	 background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); /* Firefox 3.6 - 15 */
	background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); 
	}
	.backBtn:hover{
	background: -webkit-linear-gradient(left, rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* Safari 5.1 - 6.0 */
	 background: -o-linear-gradient(right, rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* Opera 11.1 - 12.0 */
	 background: -moz-linear-gradient(right, rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* Firefox 3.6 - 15 */
	background: linear-gradient(to right,rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* 标准的语法*/
	}
	.mapTcStyle {
		background: none !important;
		box-sizing: border-box;
		border-radius: 20px;
	}

	.tcNeiTitle {
		font-size: 22px;
		height: 50px;
		padding-top: 30px;
		font-weight: bold;
		color: #69f5ff;
	}

	.tcNeiBox .leftImage {
		width: 500px;
		height: 360px;
		padding: 10px;
		box-sizing: border-box;
		box-shadow: 0 0 20px inset #2281c4;
		;
	}

	.textInfo {
		height: 360px;
		width: 100%;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 1.9;
		overflow-y: auto;
		padding-right: 10px;
		box-sizing: border-box;
	}

	#mainSf {
		width: 100%;
		height: calc(100vh - 105px);
		position: relative;
	}

	#mainSf::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		background: url('../../assets/images/allBg.png') 20px 150px no-repeat;
		background-size: 100% 100%;
		bottom: 0;
		left: 0;
		opacity: 0.5;
	}

	.leftMessageBox {
		position: absolute;
		left: 20px;
		z-index: 999;
		bottom: 50px;
		width: 360px;
		height: 185px;
		background: url('../../assets/images/leftBox.png') center no-repeat;
		background-size: 100% 100%;
		padding: 22px 31px;
	}

	.circle {
		width: 780px;
		height: 780px;
		position: absolute;
		left: -30%;
		top: calc(50% - 390px);
		opacity: 0.5;
		transform: scale(0.7);
		-o-transform: rotate(0.7);
		-webkit-transform: rotate(0.7);
		-moz-transform: rotate(0.7);

	}

	.circle1 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle1.png')center no-repeat;
		background-size: 100% 100%;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome
	}

	.circle2 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle2.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome
	}

	.circle3 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle3.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome
	}

	.circle4 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle4.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.dateWeek {
		position: absolute;
		top: 0;
		left: 0;
		width: 200px;
		height: 50px;
		color: #ffffff;
	}

	.leftMessageBox .neiBox {
		box-shadow: 0 0 50px inset rgba(0, 151, 255, 1);
		height: 140px;
		border-radius: 20px;
		padding: 17px;
		box-sizing: border-box;
	}

	.baseBody {
		width: 100%;
		height: 100vh;
		background: #000208 url('../../assets/images/bg1.png') center no-repeat;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.zwRightBox {
		width: 340px;
		height: calc(100vh - 0);
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		border-radius: 260px 0 0 160px/350px 0 0 300px;
		background: url('../../assets/images/leftBoxbg.png') center no-repeat;
		;
		background-size: 100% 100%;
		/* background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Safari 5.1 - 6.0 */
		/*  background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Opera 11.1 - 12.0 */
		/*  background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Firefox 3.6 - 15 */
		/* background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* 标准的语法 */
	}

	.zwRightBoxLine {
		width: 2px;
		height: 200px;
	}

	.zwRightMneuItem {
		background: url('../../assets/images/btnNormal.png') center no-repeat;
		background-size: 100% 100%;
		width: 230px;
		height: 62px;
		line-height: 62px;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1);
		-webkit-transform: scale(1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1);
	}

	.zwRightMneuItem:hover,.zwRightMneuItem.checked {
		background: url('../../assets/images/btnNormalChecked.png') center no-repeat;
		background-size: 100% 100%;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1.1);
		-webkit-transform: scale(1.1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1.1);
	}

	.topHead {
		width: 100%;
		height: 103px;
	}

	.topHead .leftHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/leftTop.png') center no-repeat;
		background-size: 100% 100%;
	}

	.topHead .midHead {
		width: 44%;
		height: 103px;
		background: url('../../assets/images/midTop.png') center no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-weight: bold;
		font-size: 38px;
		line-height: 93px;
		color: #FFFFFF;
	}

	.topHead .rightHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/rightTop.png') center no-repeat;
		background-size: 100% 100%;
	}
	.textInfo img{max-width: 100%;height: auto;}
</style>
